module.exports = __webpack_public_path__ + "static/media/Pendon_Hallazgos _small.adba62e3.jpg";